import { lazy, Suspense } from "react";

const DiscountsView = lazy(() => import("views/discounts"));

export const DiscountsRouteWrapper = () => {
  return (
    <Suspense fallback={null}>
      <DiscountsView />
    </Suspense>
  );
};
